import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';  // Import PropTypes explicitly
import { Layout, Box, Divider, Card } from '@shopify/polaris';
import { bullet } from '../../../assets';
import { rupee } from '../../../assets';
import Slider from "react-slick";
import "../../components/app_details/plan.scss"


const Plans = ({ appData }) => {
  const PlansCard = ({ plans }) => {
    return (

      <>
        {/* First div - Hide on mobile view */}
        <div className="hidden md:block">
          <div style={{ paddingTop: "20px" }}>
            {plans.length < 3 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4'" style={{ columnGap: '30px', rowGap: '30px' }}>
                {plans.map((plan, index) => (
                  <div key={index} className="plan-card tw-m-4 tw-flex-grow-0" style={{ width: 'auto', borderRadius: '25px', height: 'auto', minHeight: '167px' }}>
                    <div key={index} className={index === 0 ? "planCard1" : index === 2 ? "planCard3" : "planCard2"} style={{ height: '100%' }}>
                      <Card>
                        <div style={{ padding: '15px' }}>
                          <p className="" style={{ fontFamily: "sfprobold", fontSize: '14px', marginBottom: '10px', color: '#131340', fontWeight: 'bold', textTransform: 'capitalize' }}>{plan.name}</p>
                          {plan.shipment_cost === 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ fontFamily: "sfprobold", fontSize: '22px' }}>Free</span>
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span>{plan.currency === "INR" && <img src={rupee} alt="Rupee symbol" style={{ height: '26px', width: '20px' }} />}</span>
                              <span className="" style={{ fontFamily: "sfprobold", fontSize: '22px', color: '#131340' }}>
                                {formatNumberWithCommas(plan.shipment_cost)} {plan.validity}
                              </span>
                            </div>
                          )}
                          <p className="" style={{ padding: 5, fontFamily: "sfproregular", fontSize: '14px', color: '#131340' }}></p>
                          <ul style={{ paddingLeft: "20px", listStyleType: 'disc' }}> {/* Set paddingInlineStart to 0 to remove default indentation and listStyleType to 'none' to remove default bullet */}
                            {plan.features.map((feature, featureIndex) => (
                              <li key={featureIndex} className="" style={{ alignItems: 'center' }}>
                                <span style={{ textTransform: 'capitalize', fontFamily: "sfproregular", fontSize: '14px' }}>
                                  {feature}
                                </span>
                              </li>
                            ))}
                          </ul>


                        </div>
                      </Card>

                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tw-flex" style={{ columnGap: '30px' }}>
                {plans.map((plan, index) => (
                  <div key={index} className="plan-card tw-m-4 tw-flex-grow-0" style={{ width: `${100 / plans.length}%`, borderRadius: '25px', height: 'inherit' }}>
                    <div key={index} className={index === 0 ? "planCard1" : index === 2 ? "planCard3" : "planCard2"} style={{ height: '100%' }}>
                      <Card>
                        <div style={{ padding: '15px' }}>
                          <p className="" style={{ fontFamily: "sfprobold", fontSize: '14px', marginBottom: '10px', color: '#131340', fontWeight: 'bold', textTransform: 'capitalize' }}>
                            {plan.name}
                          </p>

                          {plan.plan_type === 307 && plan.payment_type === "percentage" ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ fontFamily: "sfprobold", fontSize: '22px' }}>
                                {plan.validity} {plan.percentage_value}% {plan.percentage_of}
                              </span>
                            </div>
                          ) : plan.shipment_cost === 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ fontFamily: "sfprobold", fontSize: '22px' }}>Free</span>
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {plan.currency !== "" && (
                                <span>{plan.currency === "INR" && <img src={rupee} alt="Rupee symbol" style={{ height: '26px', width: '20px' }} />}</span>
                              )}
                              <span className="" style={{ fontFamily: "sfprobold", fontSize: '22px', color: '#131340' }}>
                                {formatNumberWithCommas(plan.shipment_cost)} {plan.validity}
                              </span>
                            </div>
                          )}

                          <p className="" style={{ padding: 5, fontFamily: "sfproregular", fontSize: '14px', color: '#131340' }}></p>

                          <ul style={{ paddingLeft: "20px", listStyleType: 'disc' }}>
                            {plan.features.map((feature, featureIndex) => (
                              <li key={featureIndex} className="" style={{ alignItems: 'center' }}>
                                <span style={{ textTransform: 'capitalize', fontFamily: "sfproregular", fontSize: '14px' }}>
                                  {feature}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Card>


                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

        </div>

        {/* Second div - Show on mobile view */}
        <div className="block md:hidden">
          <div className='dots-style' style={{ borderRadius: "25px" }}>
            {plans.length === 1 ? ( // Check if plans array has only one item
              plans.map((plan, index) => (
                <div style={{ borderRadius: '25px' }} key={index}>
                  <div className="" style={{ width: '100%', borderRadius: '25px', height: 'inherit' }}>
                    <div key={index} className={index === 0 ? "planCard1" : index === 2 ? "planCard3" : "planCard2"} style={{ height: '100%', borderRadius: '25px', margin: '10px' }}>
                      <Card>
                        <div style={{ padding: '15px', borderRadius: '25px' }}>
                          <p className="" style={{ fontFamily: "sfprobold", fontSize: '14px', marginBottom: '10px', color: '#131340', fontWeight: 'bold', textTransform: 'capitalize' }}>{plan.name}</p>
                          {plan.shipment_cost === 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ fontFamily: "sfprobold", fontSize: '22px' }}>Free</span>
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span>{plan.currency === "INR" && <img src={rupee} alt="Rupee symbol" style={{ height: '26px', width: '20px' }} />}</span>
                              <span className="" style={{ fontFamily: "sfprobold", fontSize: '22px', color: '#131340' }}>
                                {formatNumberWithCommas(plan.shipment_cost)} {plan.validity}
                              </span>
                            </div>
                          )}
                          <p className="" style={{ padding: 5, fontFamily: "sfproregular", fontSize: '14px', color: '#131340' }}></p>
                          <ul style={{ paddingLeft: "20px", listStyleType: 'disc' }}>
                            {plan.features.map((feature, featureIndex) => (
                              <li key={featureIndex} className="" style={{ alignItems: 'center' }}>
                                <span style={{ textTransform: 'capitalize', fontFamily: "sfproregular", fontSize: '14px' }}>
                                  {feature}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Slider {...sliderSettings}>
                {plans.map((plan, index) => (
                  <div style={{ borderRadius: '25px' }} key={index}>
                    <div className="" style={{ width: '100%', borderRadius: '25px', height: 'inherit' }}>
                      <div key={index} className={index === 0 ? "planCard1" : index === 2 ? "planCard3" : "planCard2"} style={{ height: '100%', borderRadius: '25px', margin: '10px' }}>
                        <Card>
                          <div style={{ padding: '15px', borderRadius: '25px' }}>
                            <p className="" style={{ fontFamily: "sfprobold", fontSize: '14px', marginBottom: '10px', color: '#131340', fontWeight: 'bold', textTransform: 'capitalize' }}>{plan.name}</p>
                            {plan.shipment_cost === 0 ? (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontFamily: "sfprobold", fontSize: '22px' }}>Free</span>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span>{plan.currency === "INR" && <img src={rupee} alt="Rupee symbol" style={{ height: '26px', width: '20px' }} />}</span>
                                <span className="" style={{ fontFamily: "sfprobold", fontSize: '22px', color: '#131340' }}>
                                  {formatNumberWithCommas(plan.shipment_cost)} {plan.validity}
                                </span>
                              </div>
                            )}
                            <p className="" style={{ padding: 5, fontFamily: "sfproregular", fontSize: '14px', color: '#131340' }}></p>
                            <ul style={{ paddingLeft: "20px", listStyleType: 'disc' }}>
                              {plan.features.map((feature, featureIndex) => (
                                <li key={featureIndex} className="" style={{ alignItems: 'center' }}>
                                  <span style={{ textTransform: 'capitalize', fontFamily: "sfproregular", fontSize: '14px' }}>
                                    {feature}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>

      </>

    );
  };


  PlansCard.propTypes = {
    plans: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        shipment_cost: PropTypes.string.isRequired,
        validity: PropTypes.string.isRequired,
        features: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ).isRequired,
  };


  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  useEffect(() => {
    // Your useEffect logic goes here
  }, []);

  return (
    <div>


      {appData.plans && appData.plans.length > 0 && (<div className="container"  >

        <h2 style={{ fontFamily: "sfprobold", fontSize: '30px', color: '#0B0757', paddingTop: '20px' }}>Pricing</h2>
        <div style={{ paddingTop: '10px', }}>

          <span style={{ fontSize: "14px" }}>All charges are billed in Indian Rupees. Recurring and usage-based charges are billed every 30 days.</span>

        </div>

        {appData.plans && appData.plans.length > 0 && (
          <PlansCard plans={appData.plans} />

        )}

      </div>
      )}
    </div>
  );
};

function formatNumberWithCommas(number) {
  if (typeof number !== 'number' || isNaN(number)) return 'N/A';

  const formatter = new Intl.NumberFormat('en-IN');
  return formatter.format(number);
}

Plans.propTypes = {
  appData: PropTypes.shape({
    status: PropTypes.string.isRequired,
    app_id: PropTypes.string.isRequired,
    app_name: PropTypes.string.isRequired,
    app_icon: PropTypes.string.isRequired,
    updated_at: PropTypes.string, // Optional, adjust the type accordingly
    plans: PropTypes.arrayOf(PropTypes.any), // Optional, adjust the type accordingly
    // Add other required properties here
  }).isRequired,
};

export default Plans;